import { createSelector } from "reselect";

const getState = (state) => state;

//  Exams
export const getCategories = createSelector(
  getState,
  (state) => state.categories
);

export const getChosenCategory = createSelector(
  getState,
  (state) => state.chosenCategory
);
export const getChosenChapter = createSelector(
  getState,
  (state) => state.chosenChapter
);

// Subjects
export const getBookmarks = createSelector(getState, (state) => state.subjects);
